<div class="left-modal">
  @if (loading) {
    <div class="loader"></div>
  }
  <div class="close" (click)="close()"></div>
  @if (!loading) {
    <div class="modal-container">
      <h1>{{ (type == 'service' ? 'Service history' : 'Catering history') | translate}}</h1>
      <div class="row">
        @if (history?.length) {
          <app-table
            [headers]="headers"
            [list]="history"
            [full]="true"
            [canOrder]="false"
            [pagination]="false"
            (contextClick)="_gS.hidemenu()">
          </app-table>
        }
        @if (!history?.length) {
          <p class="text-center uppercase">
            {{'No records found' | translate}}
          </p>
        }
      </div>
    </div>
  }
</div>